import dayjs from 'dayjs';
import { helpers } from 'vuelidate/lib/validators';

export const fileExtensionValidator = (extensions) => {
  if (!Array.isArray(extensions))
    throw Error('Extensions should be provided as array');
  return (value) => {
    if (!value) {
      return true;
    }
    let file = value;
    return extensions.includes(file.name.split('.').pop());
  };
};

export const beforeDateValidator = (before) =>
  helpers.withParams({ type: 'beforeDate', b: before }, function (
    value,
    validatedObject
  ) {
    const beforeValue = helpers.ref(before, this, validatedObject);
    return dayjs(value).isBefore(beforeValue);
  });

export const afterDateValidator = (after) =>
  helpers.withParams({ type: 'afterDate', a: after }, function (
    value,
    validatedObject
  ) {
    const afterValue = helpers.ref(after, this, validatedObject);
    return dayjs(value).isAfter(afterValue);
  });

export const jsonValidator = (value) => {
  try {
    JSON.parse(value);
  } catch (e) {
    return false;
  }
  return true;
};

export const alphaSpaceValidator = helpers.regex('alpha', /^[a-zA-Z ]*$/);
export const alphaNumericValidator = helpers.regex('alpha', /^[a-zA-Z0-9 !@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]*$/);
